// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/04_cabeza_mimetika.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* visualstrategydetails.css */

/* Rotate the color scale image by 90 degrees and ensure it doesn't overlap labels */
.color-scale-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.color-scale {
    transform: rotate(90deg);
    width: auto;
    height: 100px;
    margin: 0;
    display: block;
}

@media (min-width: 640px) {
    .color-scale {
        height: 150px;
    }
}

/* Ensure the labels are positioned correctly and not overlapped */
.color-scale-wrapper .text-xs {
    z-index: 2;
}

.color-scale-wrapper .color-scale {
    z-index: 1;
}

/* Styling for the details container */
.details-container {
    border: 2px solid #fff;
    padding: 20px;
    border-radius: 8px;
    overflow: hidden;
    box-sizing: border-box;
    color: #fff;
}

/* Styling for the textarea in details */
.details-textarea {
    width: 100%;
    height: 100px;
    border: none;
    resize: none;
    background-color: transparent;
    color: #fff;
    overflow-y: auto;
}

/* Adjust image sizes and responsiveness */
@media (min-width: 768px) {
    .max-w-xs {
        max-width: 200px;
    }
}

@media (min-width: 1024px) {
    .max-w-xs {
        max-width: 250px;
    }
}

textarea.vertical-angular-range-motion {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}

.vertical-angular-range-motion-degrees {
    top: 44%;
    left: 56%;
    right: 0;
    bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/css/visualstrategydetails.css"],"names":[],"mappings":"AAAA,8BAA8B;;AAE9B,oFAAoF;AACpF;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,aAAa;IACb,SAAS;IACT,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA,kEAAkE;AAClE;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA,sCAAsC;AACtC;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,WAAW;AACf;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;AACpB;;AAEA,0CAA0C;AAC1C;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,yDAAyD;IACzD,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,QAAQ;IACR,SAAS;AACb","sourcesContent":["/* visualstrategydetails.css */\n\n/* Rotate the color scale image by 90 degrees and ensure it doesn't overlap labels */\n.color-scale-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.color-scale {\n    transform: rotate(90deg);\n    width: auto;\n    height: 100px;\n    margin: 0;\n    display: block;\n}\n\n@media (min-width: 640px) {\n    .color-scale {\n        height: 150px;\n    }\n}\n\n/* Ensure the labels are positioned correctly and not overlapped */\n.color-scale-wrapper .text-xs {\n    z-index: 2;\n}\n\n.color-scale-wrapper .color-scale {\n    z-index: 1;\n}\n\n/* Styling for the details container */\n.details-container {\n    border: 2px solid #fff;\n    padding: 20px;\n    border-radius: 8px;\n    overflow: hidden;\n    box-sizing: border-box;\n    color: #fff;\n}\n\n/* Styling for the textarea in details */\n.details-textarea {\n    width: 100%;\n    height: 100px;\n    border: none;\n    resize: none;\n    background-color: transparent;\n    color: #fff;\n    overflow-y: auto;\n}\n\n/* Adjust image sizes and responsiveness */\n@media (min-width: 768px) {\n    .max-w-xs {\n        max-width: 200px;\n    }\n}\n\n@media (min-width: 1024px) {\n    .max-w-xs {\n        max-width: 250px;\n    }\n}\n\ntextarea.vertical-angular-range-motion {\n    background-image: url(\"../assets/04_cabeza_mimetika.png\");\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n}\n\n.vertical-angular-range-motion-degrees {\n    top: 44%;\n    left: 56%;\n    right: 0;\n    bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
